import { Icon, IconProps } from "../";

export const FamilyIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5 6C21.5 7.93375 19.9338 9.5 18 9.5C16.0662 9.5 14.5 7.93375 14.5 6C14.5 4.06625 16.0662 2.5 18 2.5C19.9338 2.5 21.5 4.06625 21.5 6ZM0 17C0 13.6863 2.68629 11 6 11H7.61143C7.5385 11.3216 7.5 11.6563 7.5 12C7.5 13.3324 8.08007 14.5339 9.00536 15.3595C7.59303 16.1777 6.5 17.5035 6.5 19V22H2C0.895431 22 0 21.1046 0 20V17ZM17.5 22H22C23.1046 22 24 21.1046 24 20V17C24 13.6863 21.3137 11 18 11H16.3886C16.4615 11.3216 16.5 11.6563 16.5 12C16.5 13.3309 15.9213 14.5311 14.9903 15.357C16.4047 16.175 17.5 17.502 17.5 19V22ZM6 9.5C7.93375 9.5 9.5 7.93375 9.5 6C9.5 4.06625 7.93375 2.5 6 2.5C4.06625 2.5 2.5 4.06625 2.5 6C2.5 7.93375 4.06625 9.5 6 9.5ZM8 20C8 17.7909 9.79086 16 12 16C14.2091 16 16 17.7909 16 20V21.9406C16 21.9734 15.9734 22 15.9406 22H8.05941C8.0266 22 8 21.9734 8 21.9406V20ZM9 12C9 10.3425 10.3425 9 12 9C13.6575 9 15 10.3425 15 12C15 13.5983 13.7517 14.9037 12.1763 14.9949L12 15L11.8237 14.9949C10.2483 14.9037 9 13.5983 9 12Z"
      />
    </Icon>
  );
};
